import { dehydrate } from "@tanstack/react-query";
import HorseBettingTermsContainer from "@/components/container/HorseRacing/HorseBettingTermsContainer";
import { loadHeader } from "@/utils/ssr";

const SEO_TITLE = "Basic Terms of Horse Racing: What You Need To Know";
const SEO_DESCRIPTION =
  "Learn more about the Basic Terms of Horse Racing: Comprehensive guide to improve your odds of winning";

const HorseBettingTermsPage = () => (
  <HorseBettingTermsContainer title={SEO_TITLE} description={SEO_DESCRIPTION} />
);

export async function getServerSideProps() {
  const menuClient = await loadHeader();

  return {
    props: {
      dehydratedState: dehydrate(menuClient),
      sportSlug: "horse-racing",
    },
  };
}

export default HorseBettingTermsPage;
